<template>
    <draggable
        class="dragArea"
        tag="ul"
        @end="processItemMove"
        @update="updateItemMove"
        :list="items"
        :group="{ name: 'g1' }"
        item-key="name"
        :data-id="id"
        :clone="clone"
        :disabled="original === true"
    >
        <template #item="{ element }">
            <li class="cursor-pointer border-t" :data-id="element.id" :data-type="type"
                :class="{'bg-gray-50': element.type === 'folder', 'bg-white': element.type === 'service', 'green-colour': this.invoice_quote_service_ids_paid.includes(element.id), 'amber-colour': this.invoice_quote_service_ids_not_paid.includes(element.id)}">
                <div :id="'item-'+element.id" class="grid grid-cols-15 w-full items-center">
                    <div v-if="element.type === 'folder'"
                         class="group flex items-center hover:cursor-grab active:cursor-grabbing justify-between col-span-2 px-3 py-4 whitespace-normal text-xs text-gray-900 border-r">
                        <div class="flex items-center" @click="editFolder(element)">
                            <FolderIcon class="w-4 h-4 mr-3"></FolderIcon>
                            <span>{{ element.name }}</span>
                        </div>
                        <div class="flex gap-2 invisible group-hover:visible" v-if="original === false">
                            <Popper :hover="true" class="cursor-pointer" placement="top" content="Create New Folder">
                                <FolderAddIcon alt="Create New Folder" @click="createFolder(quote.id, element.id)"
                                               class="cursor-pointer w-4 h-4 text-gray-400 hover:text-gray-500"></FolderAddIcon>
                            </Popper>
                            <Popper :hover="true" class="cursor-pointer" placement="top" content="Remove Folder">

                                <FolderRemoveIcon alt="Remove Folder" @click="deleteFolder(element.id)"
                                                  class="cursor-pointer w-4 h-4 text-gray-400 hover:text-gray-500"></FolderRemoveIcon>
                            </Popper>
                            <Popper :hover="true" class="cursor-pointer" placement="top" content="Create New Service">

                                <DocumentAddIcon alt="Add New Service" @click="createService(element.id)"
                                                 class="cursor-pointer w-4 h-4 text-gray-400 hover:text-gray-500"></DocumentAddIcon>
                            </Popper>
                        </div>
                    </div>
                    <div v-if="element.type === 'service'"
                         class="group flex items-center hover:cursor-grab active:cursor-grabbing justify-between col-span-2 px-3 py-4 whitespace-normal text-xs text-gray-900 border-r">
                        <div class="flex items-center">
                            <SelectorIcon class="w-4 h-4 mr-3"></SelectorIcon>
                            <span>{{ element.name }}</span>
                        </div>
                        <div class="flex gap-2 invisible group-hover:visible" v-if="original === false">
                            <Popper :hover="true" class="cursor-pointer" placement="top" content="Duplicate Service">

                                <DocumentAddIcon alt="Remove Service" @click="duplicateService(element.id)"
                                                    class="cursor-pointer w-4 h-4 text-gray-400 hover:text-gray-500"></DocumentAddIcon>
                            </Popper>

                            <Popper :hover="true" class="cursor-pointer" placement="top" content="Remove Service">

                                <DocumentRemoveIcon alt="Remove Service" @click="deleteService(element.id)"
                                                    class="cursor-pointer w-4 h-4 text-gray-400 hover:text-gray-500"></DocumentRemoveIcon>
                            </Popper>

                            <Popper :hover="true" class="cursor-pointer" placement="top" content="Edit Service">

                                <PencilAltIcon alt="Edit Service" @click="editService(element)"
                                                    class="cursor-pointer w-4 h-4 text-gray-400 hover:text-gray-500"></PencilAltIcon>
                            </Popper>
                        </div>
                    </div>
                    <div class="px-3 py-4 text-xs text-gray-900 border-r">
                        <span v-if="element.starts_at">
                            {{ moment(element.starts_at, 'YYYY-MM-DD').format('DD MMM YYYY') }}
                        </span>
                        <span v-else>&nbsp;</span>
                    </div>
                    <div class="px-3 py-4 text-xs text-gray-900 border-r">
                        <span v-if="element.ends_at">
                            {{ moment(element.ends_at, 'YYYY-MM-DD').format('DD MMM YYYY') }}
                        </span>
                        <span v-else>&nbsp;</span>
                    </div>
                    <div class="col-span-2 px-3 py-4 text-xs text-gray-900 border-r test">
                        {{ element.supplier ? element.supplier.name : '&nbsp;' }}
                    </div>
                    <div class="px-3 py-4 whitespace-nowrap text-xs text-gray-900 border-r">
                        <span v-if="element.type === 'folder'">{{
                                formatCurrency(element.net_sell_total, element.quote.sell_currency.code, true)
                            }}</span>
                        <span v-else>{{
                                formatCurrency(element.sell_net_total, element.quote.sell_currency.code, true)
                            }}</span>
                    </div>
                    <div class="px-3 py-4 whitespace-nowrap text-xs text-gray-900 border-r">
                        <span v-if="element.type === 'folder'">{{
                                formatCurrency(element.gross_sell_total, element.quote.sell_currency.code, true)
                            }}</span>
                        <span v-else>{{
                                formatCurrency(element.sell_gross_total, element.quote.sell_currency.code, true)
                            }}</span>
                    </div>
                    <div class="px-3 py-4 whitespace-nowrap text-xs text-gray-900 border-r">
                        <span v-if="element.type === 'folder'">{{
                                formatCurrency(element.net_buy_total, element.quote.buy_currency.code, true)
                            }}</span>
                        <span v-else>{{
                                formatCurrency(element.buy_net_total, element.quote.buy_currency.code, true)
                            }}</span>
                    </div>
                    <div class="px-3 py-4 whitespace-nowrap text-xs text-gray-900 border-r">
                        <span v-if="element.type === 'folder'">{{
                                formatCurrency(element.gross_buy_total, element.quote.buy_currency.code, true)
                            }}</span>
                        <span v-else>{{
                                formatCurrency(element.buy_gross_total, element.quote.buy_currency.code, true)
                            }}</span>
                    </div>
                    <div class="px-3 py-4 whitespace-nowrap text-xs text-gray-900 border-r">
                        {{ formatCurrency(getManagementFeeDisplayTotal(element), element.quote.sell_currency.code, true) }}
                    </div>
                    <div class="px-3 py-4 whitespace-nowrap text-xs text-gray-900 border-r">
                        {{ formatCurrency(element.commission_net, element.quote.buy_currency.code, true) }}
                    </div>
                    <div class="px-3 py-4 whitespace-nowrap text-xs text-gray-900 border-r">
                        {{ formatCurrency(element.markup, element.quote.sell_currency.code, true) }}
                    </div>
                    <div class="px-3 py-4 whitespace-nowrap text-xs text-gray-900 border-r">{{
                            formatCurrency(element.profit, element.quote.sell_currency.code, true)
                        }}
                    </div>
                    <div class="px-3 py-4 whitespace-nowrap text-xs text-gray-900">
                        {{ number_format(parseFloat(element.profit_percentage).toFixed(2)) }}%
                    </div>
                </div>
                <NestedDraggable v-if="element.folders !== 'undefined'" type="folder" :id="'folder-'+element.id"
                                 :quote="quote"
                                 :items="element.folders"
                                 :invoice_quote_service_ids_not_paid="invoice_quote_service_ids_not_paid"
                                 :invoice_quote_service_ids_paid="invoice_quote_service_ids_paid"/>
                <NestedDraggable v-if="element.services !== null" type="service" :id="'service-'+element.id"
                                 :quote="quote"
                                 :items="element.services"
                                 :invoice_quote_service_ids_not_paid="invoice_quote_service_ids_not_paid"
                                 :invoice_quote_service_ids_paid="invoice_quote_service_ids_paid"/>
            </li>
        </template>
    </draggable>

</template>
<style>
.green-colour {
    background: rgba(81, 237, 123, 0.45);
}

.amber-colour {
    background: rgba(247, 198, 37, 0.45);
}
</style>
<script>
import draggable from "vuedraggable";
import {
    FolderIcon,
    SelectorIcon,
    FolderAddIcon,
    FolderRemoveIcon,
    DocumentAddIcon,
    DocumentRemoveIcon,
    PencilAltIcon
} from "@heroicons/vue/solid";
import {emitter} from "@/eventHub";
import moment from "moment";
import Popper from "vue3-popper";
import {usePage} from "@inertiajs/vue3";

export default {
    props: {
        items: null,
        id: {
            required: false,
            default: null
        },
        type: {
            required: true,
            default: 'folders'
        },
        quote: {
            required: true
        },
        invoice_quote_service_ids_not_paid: Array,
        invoice_quote_service_ids_paid: Array,
    },

    created() {
        this.moment = moment
    },
    data() {
        return {
            original: usePage().props.original
        }
    },
    components: {
        draggable,
        FolderIcon,
        SelectorIcon,
        FolderAddIcon,
        FolderRemoveIcon,
        DocumentAddIcon,
        DocumentRemoveIcon,
        PencilAltIcon,
        Popper
    },
    name: "nested-draggable",
    methods: {
        editFolder(folder) {
            emitter.emit("openFolderSlideout", folder);
        },
        editService(service) {
            emitter.emit("openServiceSlideout", service);
        },
        createFolder(quote_id, folder_id) {
            emitter.emit("createFolderSlideout", {quote_id: quote_id, folder_id: folder_id})
        },
        createService(folder_id) {
            emitter.emit("createServiceSlideout", folder_id)
        },
        deleteFolder(folder_id) {
            emitter.emit("deleteFolder", folder_id)
        },
        deleteService(service_id) {
            emitter.emit("deleteService", service_id)
        },
        duplicateService(service_id) {
            emitter.emit("duplicateService", service_id)
        },
        processItemMove(event) {

            emitter.emit("processItemMove", event)

        },
        updateItemMove(event) {

        },
        clone({id}) {
        },
        number_format(nStr) {
            nStr += '';
            let x = nStr.split('.');
            let x1 = x[0];
            let x2 = x.length > 1 ? '.' + x[1] : '';
            let rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        doRounding(value, decimals) {
            return Number(Math.round(value + "e" + decimals) + "e-" + decimals).toFixed(2);
        },
        getManagementFeeDisplayTotal(element) {
            const numberValue = (value) => parseFloat(value) || 0;

            if (!element || !element.type) {
                return 0;
            }

            if (element.type === 'service') {
                return numberValue(element.management_fee_total) + numberValue(element.management_fee_tax_amount);
            }

            // For folders, sum nested service management fee gross values.
            let total = 0;

            if (Array.isArray(element.services)) {
                element.services.forEach((service) => {
                    total += this.getManagementFeeDisplayTotal(service);
                });
            }

            if (Array.isArray(element.folders)) {
                element.folders.forEach((folder) => {
                    total += this.getManagementFeeDisplayTotal(folder);
                });
            }

            const hasNestedItems = 
                (Array.isArray(element.services) && element.services.length > 0) ||
                (Array.isArray(element.folders) && element.folders.length > 0);

            if (!hasNestedItems) {
                return numberValue(element.management_fee_total);
            }

            return total;
        }
    },
    computed: {
        isPaid: function () {
            if (this.id != null && this.id.includes('service')) {
                var str = this.id;
                var matches = str.match(/(\d+)/);
                var id = parseInt(matches[0]);
                return this.invoice_quote_service_ids_paid.includes(id);
            }
        }
    }

};
</script>
